import React from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";
import { Button } from "../../common/Button/Button";
import Spinner from "../../common/Spinner/Spinner";
import Checkbox from "../../common/Checkbox/Checkbox";

export default function MarkVerifiedBusinessModel(props) {
    return (
        <Modal
        isOpen={props.isOpen}
        onRequestClose={props.toggleModal}
        ariaHideApp={false}
    >
        <ModalContent className="ESP-deprenuer-modal">
            {props.isLoadingReports && <Spinner className="center" />}
            <div className="p-2 modal-header-bar">
                <span>Mark Verified</span>
                <button
                    id="verifyClose"
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={props.toggleModal}
                >
                    <X style={{ pointerEvents: "none" }} color="white" />
                </button>
            </div>
            <div
                className={`modal-body ${props.isDisabled} ${props.isLoadingReports && "set-opacity"}`}
            >
                <div className='form-group'>
                    <div>
                        <Checkbox
                            id="verified"
                            checked={props.selectedServiceRequestBusinessDetails.is_business_verified==='Yes' || false}
                            onChange={(e) => {
                                e.stopPropagation();
                                props.onBusinessDetailsChange(
                                    "is_business_verified",
                                    props.selectedServiceRequestBusinessDetails.is_business_verified==='Yes'?('No'):('Yes')
                                );
                            }}
                            label=" Is verified"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            disabled={props.selectedServiceRequestBusinessDetails.custrefSRState==="Cancelled"||props.selectedServiceRequestBusinessDetails.custrefSRState==="Delivered"}
                        />
                    </div>
                    <div>
                        {props.selectedServiceRequestBusinessDetails.custrefSRState=="Cancelled"||props.selectedServiceRequestBusinessDetails.custrefSRState=="Delivered"?
                        (
                            <Button className="float-right disabled" style={{marginTop:"10px"}}>Update</Button>
                        ):
                        (
                            <Button className="float-right" style={{marginTop:"10px"}} onClick={props.onBusinessVerifyUpdate}>Update</Button>
                        )} 
                    </div>
                    <div style={{clear:"both"}}></div>
                </div>
            </div>
        </ModalContent>
    </Modal >
    );
  }